/**
 * O selo de estado, desenhado. A geometria está em `seloDeEstado.ts`; aqui só se
 * escolhe a forma e se lhe põe um nome que um leitor de ecrã saiba dizer.
 *
 * Um componente e não dois: isto aparece no canto do avatar e no menu de estado,
 * e enquanto foram dois desenhos separados — um SVG e um `.dot` em CSS com dois
 * `::after` empilhados — divergiram. O mesmo estado com duas caras é o defeito
 * que se corrigiu quatro vezes; com um desenho só deixa de poder acontecer.
 *
 * Quem chama diz o TAMANHO e o FUNDO pelo CSS (`--selo-fundo`), porque o buraco
 * da marca deixa ver o que está por baixo e o que está por baixo muda: a barra
 * lateral num sítio, o menu no outro.
 */

import type { PresenceStatus } from "@greenvoice/shared";

import { CAMINHO_DO_ANEL, CAMINHO_DO_SELO, SELO_CAIXA, STATUS_LABEL } from "./seloDeEstado";

interface SeloProps {
  status: PresenceStatus;
  /** Classe de quem o coloca — posição e tamanho vêm de fora. */
  className?: string;
}

export function Selo({ status, className }: SeloProps) {
  return (
    <svg
      className={`selo selo--${status.toLowerCase()}${className ? ` ${className}` : ""}`}
      viewBox={`0 0 ${SELO_CAIXA} ${SELO_CAIXA}`}
      role="img"
      aria-label={STATUS_LABEL[status]}
    >
      <title>{STATUS_LABEL[status]}</title>
      <path className="selo__anel" d={CAMINHO_DO_ANEL} />
      <path className="selo__forma" fillRule="evenodd" d={CAMINHO_DO_SELO[status]} />
    </svg>
  );
}
